// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"PageContainer_pageContainer__3-WRw"};